export default {
	getProduct: ({ product }) => product,
	getSteps: ({ steps }) => steps,
};


// WEBPACK FOOTER //
// ./src/store/product/getters.js